import * as React from 'react';
import {emotionStyled} from '@packages/utilities/styled';
import {type IconProps} from './Icon.types';

const BASE_SPACING_VALUE = 4;

/**
 * Ideally, Icon should have built in props for styling layout.
 * Instead, that should be handled by a dedicated parent layout component.
 * However, due to how Icon is currently used, it's more efficient to
 * manually handle some layout adjustments to reduce the refactor scope
 * of this component.
 *
 * 2021-08-18
 * https://webflow.atlassian.net/browse/PDTY-1221
 */
function getMarginValue(margin?: number | string): string | null | undefined {
  if (typeof margin === 'string') return margin;
  if (typeof margin === 'number') return `${margin * BASE_SPACING_VALUE}px`;
  return undefined;
}

const View = emotionStyled('div')({
  alignItems: 'center',
  justifyContent: 'center',
});

/**
 * @deprecated import necessary icons from `@packages/systems/spring` instead
 */
export const Icon = (props: IconProps) => {
  const {
    color,
    height,
    inline,
    glyph,
    margin,
    marginLeft,
    marginRight,
    marginInlineStart,
    marginInlineEnd,
    style: styleProp = {},
    ...rest
  } = props;

  const style = {
    ...styleProp,
    color,
    display: inline ? 'inline-flex' : 'flex',
    height,
    marginInlineStart:
      getMarginValue(marginLeft) || getMarginValue(marginInlineStart),
    marginInlineEnd:
      getMarginValue(marginRight) || getMarginValue(marginInlineEnd),
    margin: getMarginValue(margin),
  } as const;

  return (
    <View data-legacy-ds="Icon" {...rest} style={style}>
      {glyph}
    </View>
  );
};

export default Icon;
